import TakerAtAGlance from "pages/PanelPage/components/selectedAssessment/assessmentResults/takerResults/TakerAtAGlance/TakerAtAGlance";

export default TakerAtAGlance;
